import React, { useState, Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import InputField from './InputField';
import MyAccountMySubscriptionsDetails from './MyAccountMySubscriptions.Details';
import MyAccountMySubscriptionsManageSubScription from './MyAccountMySubscriptions.ManageSubscription';

const MyAccountMySubscriptions = () => {
    const { payload } = useSelector((state) => state.myAccountMySubscriptions);
    const [isInManageSubscriptionMode, setIsInManageSubscriptionMode] = useState(false);

    const toggleManageSubscriptionMode = () => {
        setIsInManageSubscriptionMode(prev => !prev);
    }

    return (
        <Fragment>
            {payload && (
                <Fragment>
                    {isInManageSubscriptionMode 
                        ? <MyAccountMySubscriptionsManageSubScription onToggleManageSubscriptionMode={toggleManageSubscriptionMode} />
                        : <MyAccountMySubscriptionsDetails onToggleManageSubscriptionMode={toggleManageSubscriptionMode} />
                    }
                </Fragment>
            )}
        </Fragment>
    )
}

export default MyAccountMySubscriptions;